import { InstructionComponentType, AttachmentInstructionType } from '@scale/shared/defaults';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

export const waitSeconds = 5;

export const TOOL_TUTORIALS = 'ToolTutorials';
export const RICH_TEXT_TYPE_NAME = 'General';

export const iconPropsByType: Record<string, { iconColor: string; iconName: IconProp }> = {
  [InstructionComponentType.Label]: { iconColor: '#00BFA5', iconName: 'tag' },
  [InstructionComponentType.Attribute]: { iconColor: '#F8BB06', iconName: 'asterisk' },
  [InstructionComponentType.Field]: { iconColor: '#F8BB06', iconName: 'asterisk' },
  [InstructionComponentType.Rule]: { iconColor: '#EF3D57', iconName: 'pencil-ruler' },
  [InstructionComponentType.RichText]: { iconColor: '#C634C3', iconName: 'text-size' },
  [InstructionComponentType.Group]: { iconColor: '#6A11EA', iconName: 'folder' },
  [AttachmentInstructionType.Iframe]: { iconColor: '#6A11EA', iconName: 'link' },
  [AttachmentInstructionType.Image]: { iconColor: '#6A11EA', iconName: 'file-image' },
  [AttachmentInstructionType.Pdf]: { iconColor: '#6A11EA', iconName: 'file-pdf' },
  workflow: { iconColor: '#EF3D57', iconName: 'list' },
  [TOOL_TUTORIALS]: { iconColor: '#6DD2F0', iconName: 'toolbox' },
};
